import React, { useState, useEffect, useRef } from 'react'; 
import styled from 'styled-components';

import server from 'server/serverController2';
import { FooterStateActions } from 'store/actionCreators';

import LottieLoader from 'components/containers/common/LottieLoader';
import TitleHeader from 'components/presenters/header/TitleHeader';
import Presnter from 'components/presenters/task/modal/TaskReportModal';

import loadingAnimation from 'images/lottiefile/yellow_loading_animation.json';

export default function TaskReportModal({ 
    setVisible, 
    reportTargetNo, 
    setReportTargetNo, 
    onDeleteTaskTrigger, 
    handleBack = null,
    onReportComplete
}) { 
    const [selectReason, setSelectReason] = useState(null);
    const [etcText, setEtcText] = useState(null);
    const [reasonList, setReasonList] = useState([]);
    const [valid, setValid] = useState(false);
    const [reportTask, setReportTask] = useState(null);
    const [etcFieldVisible, setEtcFieldVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isEnd, setIsEnd] = useState(false);
    const [lottieOptions, setLottieOptions] = useState(null);

    const etcInputRef = useRef(null)

    useEffect(()=>{

        return ()=>{
            (FooterStateActions.updateFooterState({visible: true}))
        }

    },[])
    const handleClose = () => {
        setVisible(false);
        setReportTargetNo(null);
        FooterStateActions.updateFooterState({visible: true})
    }

    const handleSelectReasonChange = (reason) => {
        setSelectReason(reason);
    }

    const validateCheck = () => {
        if(!selectReason)
        {
            return false;
        }
        if(selectReason.no === '6')
        {
            if(!etcText)
            {
                return false;
            }
        }
        return true;
    }

    const handleEtcTextChange = (e) => {
        setEtcText(e.target.value);
    }

    const submitCallback = (res) => {
        try
        {
            if(res.success !== 1)
            {
                return;
            }
            const jsonData = res.data;
            const reportTargetTask = jsonData.inserted_item;
            setIsLoading(false);
            setIsEnd(true);
            setReportTask(reportTargetTask);
        }
        catch(err)
        {
            console.log(err);
        }
    }

    const handleSubmit = () => {
        const body = {};
        body['reason_no'] = selectReason.no;
        if(selectReason.no === '6')
        {
            body['reason'] = etcText;
        }
        setIsLoading(true);
        setLottieOptions({
            loop: true,
            autoplay: true,
            renderer: 'svg',
            animationData: loadingAnimation
        })
        server.postRequestData(`tasks/${reportTargetNo}/reports`, body, submitCallback);
    }

    useEffect(() => {
        server.getRequestData('reports/reasons?type=task', (res) => {
            if(res.success !== 1)
            {
                return;
            }
            const jsonData = res.data;
            const reasons = jsonData.reasons;
            setReasonList(reasons);
        })
        FooterStateActions.updateFooterState({visible: false})
    }, []);

    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(() => {
        setValid(validateCheck());
        if(selectReason?.name === 'others')
        {
            setEtcFieldVisible(true);

        }
        else
        {
            setEtcFieldVisible(false);
        }
    }, [selectReason, etcText])

    useEffect(() => {
        if(etcFieldVisible === true)
        {
            etcInputRef.current.focus()
        }
    }, [etcFieldVisible])

    useEffect(async () => {
        if(!isLoading && isEnd && reportTask){
            await onDeleteTaskTrigger(reportTask);
            setIsLoading(false);
            setIsEnd(false);
            if(handleBack)
            {
               await handleBack();
            }
            await handleClose()
            await onReportComplete();
        }
    }, [isLoading, isEnd, reportTask])

    return (
        <TaskReportModalWrapper>
            <FixedTopNav>
                <TitleHeader title={"인증샷 신고"} isCloseBtn={true} onBackBtn={handleClose}/>
            </FixedTopNav>
            <TaskReportBodyWrapper>
                <Presnter 
                    reasonList={reasonList}
                    selectReason={selectReason}
                    etcInputRef={etcInputRef}
                    valid={valid}
                    onSelectReasonChange={handleSelectReasonChange}
                    onEtcTextChange={handleEtcTextChange}
                    onSubmit={handleSubmit}
                    etcFieldVisible={etcFieldVisible}
                />
            </TaskReportBodyWrapper>
            {isLoading ? (
                lottieOptions ? (
                    <LoadingAnimationBlock>
                        <LottieLoader lottieOptions={lottieOptions} style={{width: 'calc(100vw * (60 / 375))'}}/>
                    </LoadingAnimationBlock>
                ) : null
            ) : null}
        </TaskReportModalWrapper>
        
    )
}

const TaskReportModalWrapper = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    z-index: 500;
    background: #fff;
    height: 100vh;
    width: 100%;
    overflow: hidden;
`;

const FixedTopNav = styled.div`
    flex: 0 1 auto;
    min-height: calc(100vw*(51/375));
    height: calc(100vw*(51/375));
`;
const TaskReportBodyWrapper = styled.div`
    flex: 1 1 auto;
    height: 100%;
    overflow: scroll;
`;

const LoadingAnimationBlock = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    z-index: 500;
`;